<template>
  <div id="user-edit-tab-info" class="mt-0" style="margin-top: 0px !important;">
    <div id="studentLogbokClassLoadingDiv" class="vs-con-loading__container">
      <div  class="vx-row" >
        <div class="vx-col w-full pt-1" align="right">
          <vs-button v-on:click.prevent="refreshLogbokClasses()" color="danger" type="gradient" icon-pack="feather" icon="icon-rotate-cw" icon-after></vs-button>
        </div>
      </div>
                       
      <vs-popup  classContent="popup-example" :title="'Book '+createBooking.title" :active.sync="bookingPopupActive">
        <form data-vv-scope="addBookingForm">
          <div id="createBookingLoadingDiv" class="vs-con-loading__container">
            <vs-tabs>
                <vs-tab label="By Location">
                  <vs-collapse v-if="classTimesByLocation.times.length" v-for="(classTimeByLocation, classTimeByLocationIndex) in classTimesByLocation.times">
                    <vs-collapse-item>
                      <div slot="header">{{ capitalizeFirstLetter(classTimeByLocation[0].class_location) }}</div>
                      <vs-list>
                        <vs-list-item v-if="classTimeByLocation[0]" :title="classTimeByLocation[0].teacher_name+' '+classTimeByLocation[0].teacher_last_name" :subtitle="classTimeByLocation[0].date+' '+classTimeByLocation[0].time_from">
                          <template slot="avatar">
                              <vs-avatar :src="classTimeByLocation[0].teacher_image"/>
                          </template>
                          <vs-button @click="clickLocationClass(classTimeByLocation[0])" color="primary" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                        </vs-list-item>
                        <vs-list-item v-if="classTimeByLocation[1]" :title="classTimeByLocation[1].teacher_name+' '+classTimeByLocation[1].teacher_last_name" :subtitle="classTimeByLocation[1].date+' '+classTimeByLocation[1].time_from">
                          <template slot="avatar">
                              <vs-avatar :src="classTimeByLocation[1].teacher_image"/>
                          </template>
                          <vs-button @click="clickLocationClass(classTimeByLocation[1])" color="primary" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                        </vs-list-item>
                        <vs-list-item v-if="classTimeByLocation[2]" :title="classTimeByLocation[2].teacher_name+' '+classTimeByLocation[2].teacher_last_name" :subtitle="classTimeByLocation[2].date+' '+classTimeByLocation[2].time_from">
                          <template slot="avatar">
                              <vs-avatar :src="classTimeByLocation[2].teacher_image"/>
                          </template>
                          <vs-button @click="clickLocationClass(classTimeByLocation[2])" color="primary" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                        </vs-list-item>
                    </vs-list>
                    <vs-button @click="showCalendarModel(classTimeByLocation)" class="mr-3 mb-2 w-full">View More - {{ capitalizeFirstLetter(classTimeByLocation[0].class_location) }}</vs-button>
                    </vs-collapse-item>
                  </vs-collapse>

                  <vs-alert color="danger" title="Not Found" :active.sync="classTimesByLocationNotFound">
                    <span>No times available for this request.</span>
                  </vs-alert>
                </vs-tab>
                <vs-tab label="By Teacher">
                  <vs-collapse v-if="classTimesByTeacher.times.length" v-for="(classTimeByTeacher, classTimeByTeacherIndex) in classTimesByTeacher.times">
                    <vs-collapse-item>
                      <div slot="header">{{ capitalizeFirstLetter(classTimeByTeacher[0].teacher_name+" "+classTimeByTeacher[0].teacher_last_name) }}</div>
                      <vs-list>
                        <vs-list-item v-if="classTimeByTeacher[0]" :title="classTimeByTeacher[0].teacher_name+' '+classTimeByTeacher[0].teacher_last_name" :subtitle="classTimeByTeacher[0].date+' '+classTimeByTeacher[0].time_from">
                          <template slot="avatar">
                              <vs-avatar :src="classTimeByTeacher[0].teacher_image"/>
                          </template>
                          <vs-button @click="clickLocationClass(classTimeByTeacher[0])" color="primary" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                        </vs-list-item>
                        <vs-list-item v-if="classTimeByTeacher[1]" :title="classTimeByTeacher[1].teacher_name+' '+classTimeByTeacher[1].teacher_last_name" :subtitle="classTimeByTeacher[1].date+' '+classTimeByTeacher[1].time_from">
                          <template slot="avatar">
                              <vs-avatar :src="classTimeByTeacher[1].teacher_image"/>
                          </template>
                          <vs-button @click="clickLocationClass(classTimeByTeacher[1])" color="primary" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                        </vs-list-item>
                        <vs-list-item v-if="classTimeByTeacher[2]" :title="classTimeByTeacher[2].teacher_name+' '+classTimeByTeacher[2].teacher_last_name" :subtitle="classTimeByTeacher[2].date+' '+classTimeByTeacher[2].time_from">
                          <template slot="avatar">
                              <vs-avatar :src="classTimeByTeacher[2].teacher_image"/>
                          </template>
                          <vs-button @click="clickLocationClass(classTimeByTeacher[2])" color="primary" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                        </vs-list-item>
                    </vs-list>
                    <vs-button @click="showCalendarModel(classTimeByTeacher)" class="mr-3 mb-2 w-full">View More - {{ capitalizeFirstLetter(classTimeByTeacher[0].teacher_name) }}</vs-button>
                    </vs-collapse-item>
                  </vs-collapse>
                  
                  <vs-alert color="danger" title="Not Found" :active.sync="classTimesByTeacherNotFound">
                    <span>No times available for this request.</span>
                  </vs-alert>
                </vs-tab>
            </vs-tabs>
          </div>
        </form>

        <vs-popup fullscreen title="fullscreen" :active.sync="calendarModelActive">
          <calendar-view
          ref="calendar"
          :displayPeriodUom="calendarView"
          :show-date="showDate"
          :events="classTimesByLocationForCalendar"
          eventBorderHeight="0px"
          eventContentHeight="1.65rem"
          class="theme-default"
          @click-event="opencClickLocationClass"
          >
            <div slot="header" class="mb-4">
              <div class="vx-row no-gutter">
                <div class="vx-col sm:w-1/2 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
                  <div class="flex items-center">
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                      @click="updateMonth(-1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full" />

                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                      @click="updateMonth(1)"
                      svgClasses="w-5 h-5 m-1"
                      class="cursor-pointer bg-primary text-white rounded-full" />
                  </div>
                </div>

                <div class="vx-col sm:w-1/2 w-full flex justify-center">
                  <template v-for="(view, index) in calendarViewTypes">
                    <vs-button
                      v-if="calendarView === view.val"
                      :key="String(view.val) + 'filled'"
                      type="filled"
                      class="p-3 md:px-8 md:py-3"
                      :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                      @click="calendarView = view.val"
                      >{{ view.label }}</vs-button>
                    <vs-button
                      v-else
                      :key="String(view.val) + 'border'"
                      type="border"
                      class="p-3 md:px-8 md:py-3"
                      :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                      @click="calendarView = view.val"
                      >{{ view.label }}</vs-button>
                  </template>
                </div>
              </div>
            </div>
          </calendar-view>

          <vs-popup class="holamundo"  title="Confirm Booking" :active.sync="calendarModelConfirmActive">
            <div class="vx-row no-gutter">
              <p>Are you to confirm booking ?</p>
              <vs-list>
                <vs-list-item title="Date" :subtitle="calendarModelConfirm.date"></vs-list-item>
                <vs-list-item title="Time" :subtitle="calendarModelConfirm.time"></vs-list-item>
                <vs-list-item title="Location" :subtitle="calendarModelConfirm.location"></vs-list-item>
                <vs-list-item v-if="calendarModelConfirm.minutes" title="Minutes" :subtitle="calendarModelConfirm.minutes.toString()"></vs-list-item>
                <vs-list-item title="Teacher" :subtitle="calendarModelConfirm.teacher_name">
                  <template slot="avatar">
                    <vs-avatar :src="calendarModelConfirm.teacher_image" />
                  </template>
                </vs-list-item>
              </vs-list>
            </div>
            <div class="vx-row no-gutter">
              <vs-button @click="calendarModelConfirmBookClass(calendarModelConfirm)" class="mr-3 mb-2 w-full">Book Class</vs-button>
            </div>
          </vs-popup>
        </vs-popup>
      </vs-popup>

      <vs-popup class="holamundo"  title="Cancel Booking" :active.sync="classCancelConfirmActive">
        <div class="vx-row no-gutter">
          <p>Are you to cancel booking ?</p>
          <vs-list>
            <vs-list-item title="Date" :subtitle="classCancelConfirm.date"></vs-list-item>
            <vs-list-item title="Time" :subtitle="classCancelConfirm.time"></vs-list-item>
            <vs-list-item title="Location" :subtitle="classCancelConfirm.location"></vs-list-item>
            <vs-list-item v-if="classCancelConfirm.minutes" title="Minutes" :subtitle="classCancelConfirm.minutes.toString()"></vs-list-item>
          </vs-list>
        </div>
        <div class="vx-row no-gutter mb-2">
          <ul class="demo-alignment">
            <span class="">Cancel By</span>
            <li><vs-radio v-model="cancelBy" vs-value="admin">Admin</vs-radio></li>
            <li><vs-radio v-model="cancelBy" vs-value="teacher">Teacher</vs-radio></li>
            <li><vs-radio v-model="cancelBy" vs-value="student">Student</vs-radio></li>
          </ul>
        </div>
        <div class="vx-row no-gutter mb-4" v-if="cancelBy == 'teacher'">
          <ul class="demo-alignment">
            <span class="">Cancel For</span>
            <li><vs-radio v-model="cancelFor" vs-value="all">Cancel teacher class</vs-radio></li>
            <li><vs-radio v-model="cancelFor" vs-value="class">Cancel student class only</vs-radio></li>
          </ul>
        </div>
        <div class="vx-row no-gutter">
          <vs-button @click="confirmCancelClass()" class="mr-3 mb-2 w-full">Cancel Class</vs-button>
        </div>
      </vs-popup>

      <vs-popup class="holamundo"  title="View Booking" :active.sync="classViewModelActive">
        <div class="vx-row no-gutter mb-2">
          <p>Booking Details</p>
          <vs-list>
            <vs-list-item title="Name" :subtitle="classView.name"></vs-list-item>
            <vs-list-item title="Date" :subtitle="classView.date"></vs-list-item>
            <vs-list-item title="Time" :subtitle="classView.time"></vs-list-item>
            <vs-list-item title="Location" :subtitle="classView.location"></vs-list-item>
            <vs-list-item v-if="classView.minutes" title="Minutes" :subtitle="classView.minutes.toString()"></vs-list-item>
          </vs-list>
        </div>
        <div class="vx-row no-gutter mb-2">
          <div class="vx-col w-1/3 mb-2">
            <span class="mr-4">Teacher sign</span>
            <vs-switch @input="updateStudentSign(classView)" v-model="classView.teacher_sign" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" />
          </div>
          <div v-if="classView.teacher_sign" class="vx-col w-1/3 mb-2">
            <span class="mr-4">Attendance</span>
            <vs-switch @input="updateStudentSign(classView)" v-model="classView.attendance" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" />
          </div>
          <div class="vx-col w-1/3 mb-2">
            <span class="mr-4">Student sign</span>
            <vs-switch @input="updateStudentSign(classView)" v-model="classView.student_sign" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" />
          </div>
          
        </div>
      </vs-popup>

      <div v-for="(currentHeyWayClass, parentIndex) in currentHeyWayClasses">
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 pr-0 w-full mb-2">
            <vs-list>
              <vs-list-header title="Classes" color="primary"></vs-list-header>
                <div v-if="currentHeyWayClass.class_details.non_booked_modules">
                  <vs-list-item v-for="(listItem, index) in currentHeyWayClass.class_details.non_booked_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                    <vs-button @click="bookAClass(listItem)" radius color="primary" type="gradient" icon-pack="feather" icon="icon-plus"></vs-button>
                  </vs-list-item>
                </div> 
            </vs-list>
          </div>
          <div class="vx-col sm:w-1/4 pr-0 w-full mb-2">
            <vs-list>
              <vs-list-header title="Booked / Rebookable" color="primary"></vs-list-header>
                <div v-if="currentHeyWayClass.class_details.booked_modules || currentHeyWayClass.class_details.past_modules">
                  <vs-list-item v-for="(listItem, index) in currentHeyWayClass.class_details.booked_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                    <div class="vx-row">
                      <vs-button class="mr-1" @click="viewAClass(listItem)" radius color="warning" type="gradient" icon-pack="feather" icon="icon-edit"></vs-button>
                      <vs-button @click="cancelClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"></vs-button>
                    </div>
                  </vs-list-item>

                  <vs-list-item v-for="(listItem, index) in currentHeyWayClass.class_details.past_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                    <div class="vx-row">
                      <vs-button class="mr-1" @click="cancelClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"></vs-button>
                      <vs-button @click="viewAClass(listItem)" radius color="dark" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                    </div>
                  </vs-list-item>
                </div> 

                <div v-if="currentHeyWayClass.class_details.completed_modules">
                  <vs-list-item v-for="(listItem, index) in currentHeyWayClass.class_details.completed_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                    <vs-button @click="bookAClass(listItem)" radius color="primary" type="gradient" icon-pack="feather" icon="icon-plus"></vs-button>
                  </vs-list-item>
                </div> 
            </vs-list>
          </div>
          <div class="vx-col sm:w-1/4 pr-0 w-full mb-2">
            <vs-list>
              <vs-list-header title="Signed" color="primary"></vs-list-header>
                <div v-if="currentHeyWayClass.class_details.student_signed_modules || currentHeyWayClass.class_details.teacher_signed_modules">
                  <vs-list-item v-for="(listItem, index) in currentHeyWayClass.class_details.student_signed_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                    <div class="vx-row">
                      <vs-button class="mr-1" @click="cancelClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"></vs-button>
                      <vs-button @click="viewAClass(listItem)" radius color="dark" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                    </div>
                  </vs-list-item>

                  <vs-list-item v-for="(listItem, index) in currentHeyWayClass.class_details.teacher_signed_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                    <div class="vx-row">
                      <vs-button class="mr-1" @click="cancelClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"></vs-button>
                      <vs-button @click="viewAClass(listItem)" radius color="dark" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                    </div>
                  </vs-list-item>
                </div> 
            </vs-list>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <vs-list>
              <vs-list-header title="Completed" color="primary"></vs-list-header>
              <div v-if="currentHeyWayClass.class_details.completed_modules">
                <div class="vs-list--item" v-for="(listItem, index) in currentHeyWayClass.class_details.completed_modules" :key="index">
                  <div class="vs-list--avatar">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                  </div>
                  <div class="list-titles">
                    <div class="vs-list--title">{{listItem.name}}</div>
                    <div class="vs-list--subtitle">{{ getDateString(listItem.booked_date)+' > '+getDateString(listItem.signed_date) }}</div>
                    <div  class="vx-row ml-1">
                      <p style="font-size: 20px;" v-for="(feedback, feedbackIndex) in listItem.teacher_feedbacks" :key="feedbackIndex" v-html="getEmojiWithId(feedback.answer)"></p>
                    </div>
                  </div>
                  <div class="vs-list--slot">
                    <div class="vx-row">
                      <!-- <vs-button class="mr-1" @click="cancelClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"></vs-button> -->
                      <vs-button class="mr-2" @click="viewAClass(listItem)" radius color="success" type="gradient" icon-pack="feather" icon="icon-zoom-in"></vs-button>
                    </div>
                  </div>
                </div>
              </div>



       
            </vs-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleClassManagement from '@/store/class-management/moduleClassManagement.js'
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require("vue-simple-calendar/static/css/default.css")

export default {
  components: {
    vSelect,
    flatPickr,
    Datepicker,
    VuePerfectScrollbar,
     CalendarView,
    CalendarViewHeader,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    heyway_class: {
      // type: Array,
      required: true,
    },
  },
  data() {
    return {
      active1: true,
      bookingPopupActive : false,
      bookingEditPopupActive : false,
      selectedTeacher : {},
      data_local: JSON.parse(JSON.stringify(this.data)),
      // currentHeyWayClass: JSON.parse(JSON.stringify(this.logbok_class)),
      // currentHeyWayClass: this.logbok_class,
      currentHeyWayClasses: JSON.parse(JSON.stringify(this.heyway_class)),
      classTimesByLocation: {
        date_from : null,
        date_to : null,
        times : [],
        days : [],
      },
      classTimesByTeacher: {
        date_from : null,
        date_to : null,
        times : [],
        days : [],
      },
      calendarModelActive : false,
      calendarModelConfirmActive : false,
      calendarModelConfirm : {
        id : null,
        date : null,
        time : null,
        minutes : null,
        location : null,
        teacher_id : null,
        teacher_name : null,
        teacher_image : null,
        module_id: null,
        package_id: null,
        student_id: null,
      },
      classCancelConfirmActive : false,
      classCancelConfirm : {
        id : null,
        date : null,
        time : null,
        minutes : null,
        location : null,
        module_id: null,
        package_id: null,
        student_id: null,
      },
      cancelBy : 'admin',
      cancelFor : 'all',
      classViewModelActive : false,
      classView : {
        id : null,
        date : null,
        time : null,
        name : null,
        minutes : null,
        location : null,
        teacher_id : null,
        teacher_name : null,
        teacher_image : null,
        module_id: null,
        package_id: null,
        student_id: null,
        student_sign : null,
        teacher_sign : null,
        attendance : null,
      },

      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',



      url: '',
      calendarView: 'month',

      activePromptAddEvent: true,
      activePromptEditEvent: true,

      calendarViewTypes: [
        {
          label: "Month",
          val: "month"
        },
        {
          label: "Week",
          val: "week"
        },
        {
          label: "Year",
          val: "year"
        },
      ],
      classTimesByLocationForCalendar : [{
        id: 1,
        title: 'My Event',
        startDate: new Date(new Date()),
        endDate: new Date(new Date()),
        url: '',
        classes: 'event-success',
        label: 'business'
      }],
      classTimesByLocationNotFound : false,
      classTimesByTeacherNotFound : false,

      createBooking : {
        title : null,
        date : null,
        studentName : null,
        packageName : null,
        packageId : null,
        moduleId : null,
        teacher : null,
      },


      showCreateBookingError : true,

      langOptions: [
        { label: "English",  value: "english"  },
        { label: "Spanish",  value: "spanish"  },
        { label: "French",   value: "french"   },
        { label: "Russian",  value: "russian"  },
        { label: "German",   value: "german"   },
        { label: "Arabic",   value: "arabic"   },
        { label: "Sanskrit", value: "sanskrit" },
      ],

      time_config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'H:i',
        // locale: Hindi, // locale for this instance only          
      },   
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    },
    teachersData() {
      let teachers = this.$store.state.userManagement.teachers
      let teachersData = []

      teachers.forEach(function(entry, key) {
        teachersData.push({
          id : entry.id,
          image : entry.image,
          title : entry.name+" "+entry.last_name,
        })
      });

      return teachersData
    },
    validForm() {
        return this.title != '' && this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo() {
        return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.endDate) }
    },
    labelColor() {
        return (label) => {
            if (label == "business") return "success"
            else if (label == "work") return "warning"
            if (label == "personal") return "danger"
            if (label == "none") return "primary"
        }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    getDateString(date) {
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      return (`${ye}-${mo}-${da}`);
    },
    getEmojiWithId(id){
      if(id == 1) return "&#128528;"
      else if(id == 2) return "&#128578;"
      else if(id == 3) return "&#128512;"
      else if(id == 4) return "&#129321;"
      return "";
    },
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
    },
    handleDayChanged(data) {
      console.log("day")
    },
    handleMonthChanged(data) {
      console.log("month")
    },
    testFun() {
      console.log("data")
    },
    cancelClassConfirm() {
      this.bookingEditPopupActive = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure to cancel this class ?',
        accept: this.cancelClass,
        cancel: this.stopCancelClass,
      })
    },
    cancelClass() {
      this.bookingEditPopupActive = true
      this.$vs.loading()

      var bookingData = {
        cancel_by : 'me',
        student_id : this.data_local.id,
        log_book_booking_id : this.editBooking.booked_id,
      }

      this.$store.dispatch("classManagement/cancelLogBokClass", bookingData)
        .then(res => { 
          this.$vs.loading.close()
          if(res.status == 201){
            this.bookingEditPopupActive = false

            this.$vs.notify({
                title: "Success.",
                text: "Class cancelled successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            this.fetchUserLogbokClass(bookingData.student_id)
          }
        })
        .catch(err => { 
          this.$vs.loading.close()
        })
    },
    stopCancelClass() {
      this.bookingEditPopupActive = true
    },
    refreshLogbokClasses() {
      this.$vs.loading({
          container: '#studentLogbokClassLoadingDiv',
          scale: 0.6
      })

      this.fetchUserLogbokClass(this.data_local.id)
    },
    validateEditBookingForm() {
      this.$validator.validateAll('editBookingForm').then(result => {
        if (result) this.editAClassFun()
        else{
          
        }
      })
    },
    validateBookingForm() {
      this.$validator.validateAll('addBookingForm').then(result => {
        if (result) this.bookAClassFun()
        else{
          
        }
      })
    },
    bookAClassFun() {
      this.$vs.loading({
          container: '#createBookingLoadingDiv',
          scale: 0.6
      })

      var bookingData = {
        student_id : this.data_local.id,
        teacher_id : this.createBooking.teacher.id,
        package_id : this.createBooking.packageId,
        module_id : this.createBooking.moduleId,
        time : this.createBooking.time,
        date : this.getDateString(this.createBooking.date),
      }

      this.$store.dispatch("classManagement/bookLogBokClass", bookingData)
        .then(res => { 
          if(res.status == 201){
            this.$vs.notify({
                title: "Success.",
                text: "Class booked successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            this.bookingPopupActive = false
            this.fetchUserLogbokClass(bookingData.student_id)
          }
          else if(res.status == 200){
            this.showCreateBookingError = true
            this.$vs.notify({
              time:4000,
              title:'',
              text: (res.data.error.message) ? res.data.error.message : 'Error in booking.',
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            });
          }

          this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
        })
        .catch(err => { 
          this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
        })
    },
    editAClassFun() {
      this.$vs.loading()

      var bookingData = {
        log_book_booking_id : this.editBooking.booked_id,
        student_id : this.data_local.id,
        teacher_id : this.editBooking.teacher.id,
        package_id : this.editBooking.package_id,
        module_id : this.editBooking.id,
        date : this.getDateString(this.editBooking.date),
        time : (this.editBooking.time == '') ? null : this.editBooking.time,
        teacher_sign : this.editBooking.teacher_sign,
        attendance : 'Present',
        result : 'pass',
        signed_date : this.getDateString(this.editBooking.signed_date_),
        signed_time : this.editBooking.signed_time,
        signed_descrition : this.editBooking.signed_descrition,
      }

      this.$store.dispatch("classManagement/editLogBokClass", bookingData)
        .then(res => { 
          this.$vs.loading.close()
          if(res.status == 201){
            this.$vs.notify({
                title: "Success.",
                text: "Class updated successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            this.fetchUserLogbokClass(bookingData.student_id)
          }
        })
        .catch(err => { 
          this.$vs.loading.close()
        })
    },
    fetchUserLogbokClass(userId) {
      this.$store.dispatch("userManagement/fetchStudentHeyWayClasses", userId)
        .then(res => { 
          this.$vs.loading.close('#studentLogbokClassLoadingDiv > .con-vs-loading')
          this.currentHeyWayClasses = res.data
          // this.$emit('logbok_class', this.logbok_class)
        })
        .catch(err => {
          this.$vs.loading.close('#studentLogbokClassLoadingDiv > .con-vs-loading')
          // console.error(err) 
        })
    },
    getDateString(date) {
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      return (`${ye}-${mo}-${da}`);
    },
    bookAClass(classItem) {
      this.classTimesByLocation = {
        date_from : null,
        date_to : null,
        times : [],
        days : [],
      }

      this.classTimesByTeacher = {
        date_from : null,
        date_to : null,
        times : [],
        days : [],
      }
      this.classTimesByTeacherNotFound = false
      this.classTimesByLocationNotFound = false
      this.bookingPopupActive = true
      this.createBooking.title = classItem.name
      this.createBooking.moduleId = classItem.id
      this.createBooking.packageId = classItem.package_id
      this.createBooking.studentName = this.data_local.name+" "+this.data_local.last_name

      this.$vs.loading({
        container: '#createBookingLoadingDiv',
        scale: 0.6
      })

      let data = {
        module_id: classItem.id,
        package_id: classItem.package_id,
        student_id: this.data_local.id,
      }
      
      this.calendarModelConfirm.module_id = classItem.id
      this.calendarModelConfirm.package_id = classItem.package_id
      this.calendarModelConfirm.student_id = this.data_local.id

      this.$store.dispatch("userManagement/getTimeByLocation", data)
        .then(res => { 
          this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
          this.classTimesByLocation = res.data
        })
        .catch(err => {
          this.classTimesByLocationNotFound = true
          this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
        })

      this.$store.dispatch("userManagement/getTimeByTeacher", data)
        .then(res => { 
          // this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
          this.classTimesByTeacher = res.data
        })
        .catch(err => {
          this.classTimesByTeacherNotFound = true
          // this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
        })
    },
    showCalendarModel(classTimeByLocation) {
      var classTimesByLocationForCalendar = [];
      classTimeByLocation.forEach(function(entry) {
        let classLocation = entry.class_location ? entry.class_location : "";
        classTimesByLocationForCalendar.push({
          id : entry.id,
          title: classLocation+' '+entry.time_from,
          startDate: new Date(entry.date+" "+entry.time_from),
          endDate: new Date(entry.date+" "+entry.time_to),
          url: '',
          classes: ['event-success', 'cursor-pointer'],
          label: 'business',
          date : entry.date,
          time : entry.time_from,
          location : entry.class_location,
          teacher_id : entry.teacher_id,
          teacher_name : entry.teacher_name,
          teacher_image : entry.teacher_image,
          minutes : entry.minutes,
        });
      });

      this.calendarModelActive = true
      this.classTimesByLocationForCalendar = classTimesByLocationForCalendar
    },
    opencClickLocationClass(locationTime) {
      let calendarModelConfirm = {
        id : locationTime.originalEvent.id,
        date : locationTime.originalEvent.date,
        time : locationTime.originalEvent.time,
        location : locationTime.originalEvent.location,
        teacher_id : locationTime.originalEvent.teacher_id,
        teacher_name : locationTime.originalEvent.teacher_name,
        teacher_image : locationTime.originalEvent.teacher_image,
        minutes : locationTime.originalEvent.minutes,
        module_id : this.calendarModelConfirm.module_id,
        package_id : this.calendarModelConfirm.package_id,
        student_id : this.calendarModelConfirm.student_id,
      }

      this.calendarModelConfirm = calendarModelConfirm;
      this.calendarModelConfirmActive = true;
    },
    clickLocationClass(locationTime) {
      let calendarModelConfirm = {
        id : locationTime.id,
        date : locationTime.date,
        time : locationTime.time_from,
        location : locationTime.class_location,
        teacher_id : locationTime.teacher_id,
        teacher_name : locationTime.teacher_name,
        teacher_image : locationTime.teacher_image,
        minutes : locationTime.minutes,
        module_id : this.calendarModelConfirm.module_id,
        package_id : this.calendarModelConfirm.package_id,
        student_id : this.calendarModelConfirm.student_id,
      }

      this.calendarModelConfirm = calendarModelConfirm;
      this.calendarModelConfirmActive = true;

    },
    calendarModelConfirmBookClass(locationTimeData) {
      this.$vs.loading({ color: 'primary' })
            
      let bookingData = {
        teacher_bookings_id : locationTimeData.id,
        student_id : locationTimeData.student_id,
        package_id : locationTimeData.package_id,
        module_id : locationTimeData.module_id,
        payment_type: "manual",
      }

      this.$store.dispatch("userManagement/bookClassByLocation", bookingData)
        .then(res => { 
          this.bookingPopupActive = false
          this.calendarModelActive = false
          this.calendarModelConfirmActive = false
          this.fetchUserLogbokClass(locationTimeData.student_id)
          this.$vs.loading.close()
          
          if(res.status == 201){
            this.$vs.notify({
              title: "Success.",
              text: "Class Successfully Bookedd.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success"
            });
          }
          else if(res.status == 200){
            this.$vs.notify({
              title: "Error.",
              text: res.data.error.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning"
            });
          }
          
        })
        .catch(err => {
          this.$vs.loading.close()
        })
    },
    cancelClass(classData) {
      this.classCancelConfirm.id = classData.booked_id
      this.classCancelConfirm.date = classData.booked_date
      this.classCancelConfirm.time = classData.booked_time
      this.classCancelConfirm.location = classData.location
      this.classCancelConfirmActive = true
    },
    confirmCancelClass() {
      this.$vs.loading({ color: 'primary' })
    
      if(this.cancelBy == "admin"){
        this.$store.dispatch("userManagement/confirmCancelClassByAdmin", this.classCancelConfirm.id)
          .then(res => { 
            this.classCancelConfirmActive = false
            this.fetchUserLogbokClass(this.data_local.id)
            this.$vs.loading.close()

            this.$vs.notify({
              title: "Success.",
              text: "Class Successfully Cancelled.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success"
            });
          })
          .catch(err => {
            this.$vs.loading.close()
          })
      }
      else if(this.cancelBy == "teacher"){

        this.$store.dispatch("userManagement/confirmCancelClassByTeacher", {student_bookings_id : this.classCancelConfirm.id, cancel_for : this.cancelFor})
          .then(res => { 
            this.classCancelConfirmActive = false
            this.fetchUserLogbokClass(this.data_local.id)
            this.$vs.loading.close()

            this.$vs.notify({
              title: "Success.",
              text: "Class Successfully Cancelled.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success"
            });
          })
          .catch(err => {
            this.$vs.loading.close()
          })
      }
      else if(this.cancelBy == "student"){
        this.$store.dispatch("userManagement/confirmCancelClassByStudent", this.classCancelConfirm.id)
          .then(res => { 
            this.classCancelConfirmActive = false
            this.fetchUserLogbokClass(this.data_local.id)
            this.$vs.loading.close()

            this.$vs.notify({
              title: "Success.",
              text: "Class Successfully Cancelled.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success"
            });
          })
          .catch(err => {
            this.$vs.loading.close()
          })
      }
    },
    viewAClass(classItem) {
      this.classView.id = classItem.booked_id
      this.classView.date = classItem.booked_date
      this.classView.time = classItem.booked_time
      this.classView.location = classItem.location
      this.classView.name = classItem.name
      this.classView.student_sign = (classItem.student_sign == "1") ? true : false
      this.classView.teacher_sign = (classItem.teacher_sign == "1") ? true : false
      this.classView.attendance = (classItem.attendance == "Present") ? true : false
      this.classViewModelActive = true
    },
    updateStudentSign(classItem){
      let data = {
        student_id : this.data_local.id,
        student_bookings_id : classItem.id,
        student_sign : (classItem.student_sign) ? '1' : '0',
        teacher_sign : (classItem.teacher_sign) ? '1' : '0',
        attendance : (classItem.attendance) ? 'Present' : 'Absent',
      }

      this.$store.dispatch("userManagement/updateStudentSign", data)
        .then(res => { 
          this.fetchUserLogbokClass(this.data_local.id)
          this.$vs.notify({
            title: "Success.",
            text: "Class Successfully Updated.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => {
          
        })
    },











    editAClass(classItem) {
      this.bookingEditPopupActive = true
      this.editBooking = classItem
      this.editBooking.title = classItem.name
      this.editBooking.teacher_sign = (classItem.teacher_sign == '1') ? true : false
      this.editBooking.studentName = this.data_local.name+" "+this.data_local.last_name



      if(this.teachersData.length && classItem.teacher_data.id){
        let filterTeacherData = this.teachersData.filter(function (entry) {
          return entry.id == classItem.teacher_data.id;
        });

        if(filterTeacherData.length > 0) this.editBooking.teacher = filterTeacherData[0]
        // if(filterTeacherData.length > 0) this.editBooking.teacher = Object.assign({}, filterTeacherData[0])
      }
    },
    editAClassChangeTeacher() {
      let newSelectedTeacher = this.editBooking.teacher
      let newSelectedTeacherSign = this.editBooking.teacher_sign
      this.editBooking.teacher_sign = !newSelectedTeacherSign
      this.editBooking.teacher = newSelectedTeacher
      this.editBooking.teacher_sign = newSelectedTeacherSign
    },
    save_changes() {
      if(!this.validateForm)return
    
    },
    reset_data() {
      this.data_local = Object.assign({}, this.data)
    },
    addEvent() {
        const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
        obj.classes = "event-" + this.labelColor(this.labelLocal)
        this.$store.dispatch('calendar/addEvent', obj);
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },




    openEditEvent(event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true;
    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    }
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if(!moduleClassManagement.isRegistered) {
      this.$store.registerModule('classManagement', moduleClassManagement)
      moduleClassManagement.isRegistered = true
    }

    this.$store.dispatch("userManagement/fetchTeachers").catch(err => { console.error(err) })

  },
  mounted(){
    this.refreshLogbokClasses()
  }
}
</script>

<style type="text/css">

#createBookingLoadingDiv{
  min-height: 50px !important;
}
.vdp-datepicker .vdp-datepicker__calendar {
    z-index: 60000 !important;
    /*position: relative;*/
    width: 270px;
    border-radius: 5px !important;
}

::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

</style>